export enum OrganizationStatus {
  ORGANIZATION_STATUS_APPROVED = 1,
  ORGANIZATION_STATUS_REJECTED = 2,
  ORGANIZATION_STATUS_WAITING_FOR_APPROVAL = 3
}
